import { Block } from '@chameleoncreator/creator-app';

const findHeaderElementByType = (blocks, type) => {
  return Object.values(blocks).find(block => {
    return (block as Block).type === type;
  });
};

export const addHeaderBlocksToStateAction = (dispatch, getState) => {
  const { blocks } = getState();

  const header = findHeaderElementByType(
    blocks,
    'Header'
  ) as Block;

  const standardHeader = findHeaderElementByType(
    blocks,
    'StandardHeader'
  ) as Block;

  const graphicHeader = findHeaderElementByType(
    blocks,
    'GraphicHeader'
  ) as Block;

  const [standardHeaderLogo] = (
    (standardHeader?.children as Block[]) || []
  ).map(child => {
    return blocks[child.id];
  });

  const [graphicHeaderBackground, graphicHeaderLogo] = (
    (graphicHeader?.children as Block[]) || []
  ).map(child => {
    return blocks[child.id];
  });

  dispatch({
    type: 'ADD_HEADER_BLOCKS_TO_STATE',
    data: {
      header,
      standardHeader,
      graphicHeader,
      standardHeaderLogo,
      graphicHeaderBackground,
      graphicHeaderLogo,
    },
  });
};
